import axios from "axios";
import { Toast } from "vant";
const _axios = axios.create({
  // timeout: 5000
  // baseURL: process.env.NODE_ENV === 'production' ? window.g.baseUrl + '/api/newlive' : '/api/newlive',
  baseURL:'/api/newlive',
    // timeout: 5000 // request timeout
});

// 请求拦截器配置
_axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器配置
_axios.interceptors.response.use(
  (response) => {
    if (response.data.status !== 0) {
      Toast.fail(response.data.desc);
    }
    return response;
  },
  (error) => {
    if (error.response.status === 500) {
      Toast.fail(error.response.data.desc);
    } else if (error.response.status === 504) {
      Toast.fail("请求超时，请稍后重试");
    } else {
      Toast.fail("服务异常，请联系管理员");
    }

    Promise.reject(error);
  }
);

export default _axios;
